module.exports = __webpack_public_path__ + "img/w32.a06ab326.svg";